import React, { useState, useEffect } from 'react';
import { Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { RefreshCw } from 'react-feather';
import Select from 'react-select';

const TextBox = (props) => {
  const {
    volume,
    setVolume,
    speedValue,
    setSpeedValue,
    selectedVoice,
    setSelectedVoice,
    vendors,
    selectedVendor,
    setSelectedVendor,
    languages,
    selectedLanguage,
    setSelectedLanguage,
    genders,
    selectedGender,
    setSelectedGender,
    voicesForLanguage,
    fileFormatValue,
    setFileFormatValue
  } = props;

  const handleVolume = (e) => {
    setVolume(e.target.value);
  };

  const handleResetRange = () => {
    setVolume(1);
    setSpeedValue(1);
  };

  const fileFormat = [
    { id: 1, name: 'mp3' },
    { id: 2, name: 'wav' },
    { id: 3, name: 'mu-law' }
  ];

  useEffect(() => {
    setSelectedLanguage('');
    setSelectedGender('');
    setSelectedVoice('');
  }, [selectedVendor]);

  useEffect(() => {
    setSelectedVoice('');
    setSelectedGender('');
  }, [selectedLanguage]);

  useEffect(() => {
    setSelectedVoice('');
  }, [selectedGender]);

  return (
    <div className="voice-controls p-1 shadow m-2">
      <h2 className="border-bottom text-primary">Voice Controls</h2>
      <Form>
        <FormGroup className="form-group">
          <Label for="Vendor" className="text-primary">
            Vendor
          </Label>
          <Select
            options={vendors}
            value={selectedVendor}
            onChange={setSelectedVendor}
            isSearchable={false}
            isClearable={false}
            placeholder="Select vendor"
            name="vendor"
          />
        </FormGroup>

        <FormGroup className="form-group">
          <Label for="Language" className="text-primary">
            Language
          </Label>
          <Select
            options={languages}
            value={selectedLanguage}
            onChange={setSelectedLanguage}
            isSearchable={false}
            isClearable={false}
            isDisabled={!selectedVendor}
            placeholder="Select language"
            name="language"
          />
        </FormGroup>

        <FormGroup className="form-group">
          <Label for="voice" className="text-primary">
            Voice Gender
          </Label>
          <Select
            options={genders}
            value={selectedGender}
            onChange={setSelectedGender}
            isSearchable={false}
            isClearable={false}
            isDisabled={!selectedLanguage}
            placeholder="Select gender"
          />
        </FormGroup>

        <FormGroup className="form-group">
          <Label for="voice" className="text-primary">
            Voice
          </Label>
          <Select
            options={voicesForLanguage}
            value={selectedVoice}
            onChange={setSelectedVoice}
            isSearchable={true}
            isClearable={false}
            isDisabled={!selectedGender}
            placeholder="Select voice"
          />
        </FormGroup>
        <FormGroup className="form-group">
          <Label for="Language" className="text-primary">
            File format
          </Label>
          <Input
            type="select"
            name="file-format"
            id="file-format"
            placeholder='Enter "file-format"'
            value={fileFormatValue}
            onChange={(e) => setFileFormatValue(e.target.value)}>
            {fileFormat.map((item) => (
              <option key={item.id}>{item.name}</option>
            ))}
          </Input>
        </FormGroup>
        <FormGroup className="range-group">
          <div className="d-flex justify-content-between">
            <Label for="Language" className="text-primary">
              Speed
            </Label>
            <span className="counter">{speedValue}</span>
          </div>
          <Input
            id="speed"
            name="speed"
            type="range"
            min="0.25"
            max="2"
            step="0.01"
            value={speedValue}
            onChange={(e) => setSpeedValue(e.target.value)}
          />
        </FormGroup>
        <FormGroup className="range-group">
          <div className="d-flex justify-content-between">
            <Label for="Volume" className="text-primary">
              Volume
            </Label>
            <span className="counter">{volume}</span>
          </div>
          <Input
            id="Volume"
            name="Volume"
            type="range"
            bsSize="lg"
            min="0.25"
            max="2"
            step="0.01"
            value={volume}
            onChange={handleVolume}
          />
          <span
            className=" align-self-end"
            tabIndex="0"
            data-toggle="tooltip"
            title="Rest Volume and Pitch">
            <RefreshCw
              size={20}
              onClick={handleResetRange}
              className="align-self-end text-primary refresh-btn"
            />
          </span>
        </FormGroup>
      </Form>
    </div>
  );
};

export default TextBox;
